import DevourClient from 'devour-client';

export const TYPE = 'comment';

export default function (client: DevourClient) {
	client.define(
		TYPE,
		{
			content: '',
		},
		{
			type: TYPE,
		}
	);

	return client;
}
